<template>
  <v-card outlined width="100%" class="my-3">
    <v-card-text class="pa-0">
      <v-row class="ma-0">
        <v-col cols="12" sm="12" md="12" class="pa-0" v-if="loaderLoading">
          <v-skeleton-loader
            type="image, image, image"
            width="100%"
            :height="getHeight"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
          class="pa-0"
          v-else-if="hoooldersStockUrl"
        >
          <iframe
            :title="$t('menu.stockAnalysis')"
            style="border: none !important"
            width="100%"
            :height="getHeight"
            :src="hoooldersStockUrl"
          >
          </iframe>
        </v-col>
        <v-col cols="12" sm="12" md="12" class="pa-0" v-else>
          <v-card flat class="mx-auto" :height="getHeight">
            <v-card-text>
              <p class="text-center">
                <strong style="color: #404040">
                  {{ $t(errorMsg) }}
                </strong>
              </p>
              <p class="text-center">
                <strong>
                  {{ $t("msgContactSupport") }}
                </strong>
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <Loader :loading="loaderLoading" :message="loaderText"></Loader>
  </v-card>
</template>

<script>
import Loader from "@/components/Loader.vue";
import { mapActions, mapState } from "vuex";
export default {
  name: "HoolderStockAnalysis",
  components: {
    Loader,
  },
  data() {
    return {
      loaderLoading: false,
      errorMsg: "",
    };
  },
  computed: {
    ...mapState({
      stockDetails: (state) => state.stock.stockDetails,
    }),
    loaderText() {
      return this.$t("LoaderText");
    },
    getHeight() {
      return window.innerHeight - 170;
    },
    hoooldersStockUrl() {
      return this.stockDetails.hoolders_url;
    },
  },
  methods: {
    ...mapActions({
      getStocksData: "stock/getStocks",
    }),
  },
  async mounted() {
    try {
      this.loaderLoading = true;
      await this.getStocksData();
    } catch (error) {
      this.errorMsg = error.response.data.jp_response_key;
      console.error(error);
    } finally {
      this.loaderLoading = false;
    }
  },
};
</script>

<style>
</style>